import React, { useState, useEffect, useRef, useContext } from 'react';
import ContactForm from './ContactForm'
import {FormProvider} from '@thinkwell/react.common'
import {EditModal} from '@thinkwell/react.polaris'
import {HostContext} from './contexts/Host'
import pick from 'lodash/pick'

export default function EditContact(props) {
  const host = useContext(HostContext)
  const data = pick(props.item, ['email', 'first_name', 'last_name'])

  const onSave = (contact) => {
    const updatedItem = Object.assign({}, props.item, contact)
    props.onSave && props.onSave(updatedItem)
  }

  return (<FormProvider data={data}><EditModal
      onSave={onSave}
      url={props.forAccount ? `${host}/accounts/${props.item.id}?shop_name=${props.shop_name}` : `/admin/customers/${props.item.id}`}
      title="Edit Contact">
      <ContactForm withPhone={props.withPhone} />
    </EditModal></FormProvider>
  );
}
